import { createContext, useContext } from 'react';
import { noOp } from '../../utils/functions';

export type SetSidebarStateContextType = {
  setSidebarState: (newState: boolean) => void,
  openSidebar: () => void,
  closeSidebar: () => void
};

export const SidebarStateContext = createContext<boolean>(false);
export const SetSidebarStateContext = createContext<SetSidebarStateContextType>({
  setSidebarState: noOp,
  openSidebar: noOp,
  closeSidebar: noOp,
});

export function useIsSidebarExpanded(): boolean {
  return useContext(SidebarStateContext);
}

export function useSetSidebarStateContext(): SetSidebarStateContextType {
  return useContext(SetSidebarStateContext);
}

export function useSetSidebarState(): (newState: boolean) => void {
  return useSetSidebarStateContext().setSidebarState;
}

export function useOpenSidebar(): () => void {
  return useSetSidebarStateContext().openSidebar;
}

export function useCloseSidebar(): () => void {
  return useSetSidebarStateContext().closeSidebar;
}
